<template>
    <div>
        <app-form 
            v-bind:parentObject = "{
                data: this.form,
                item: this.item,
                pageTitle: this.pageTitle,
                pageTitleValue: this.pageTitleValue,
                errMsg: this.errMsg,
                isEdit: this.editMode,
                isWizard: this.isWizard
            }"
        />
        <div v-if="isErr">
            <app-error 
                v-bind:parentError ="{
                    data: this.errMsg,
                    isErr: this.isErr
                }"
            />
        </div>    
    </div>
</template>

<script>
import KpiSettingForm from '../../../components/performancemanagement/targetsetting/Form_StaffExercise';
import ErrorDialog from '../../../components/common/ErrorDialog';

export default {
    components: {
        'app-form': KpiSettingForm,
        'app-error': ErrorDialog
    },

    data() {
        return{
            pageTitle: this.$t('performancemanagement.kpisettingfor'),
            // pageTitleValue: `${this.$route.params.item.staffcode} - ${this.$route.params.item.staffname}` + ` for Exercise ` + `${this.$route.params.item.kpiexercode}`,
            pageTitleValue: `${this.$route.params.item.staffcode} - ${this.$route.params.item.staffname} ${this.$t('performancemanagement.forexercise')} ${this.$route.params.item.kpiexercode}`,

            id: this.$route.params.id,
            item: this.$route.params.item,
            form: this.$route.params.form,       

            errMsg: '',
            isErr:false,
            editMode: false,
            isWizard: false,
        }
    },
        

    methods: {
        
        
    },

    mounted () {
        console.log(this.$route.params.id, 'id');
        console.log(this.$route.params.item, 'item');
        console.log(this.$route.params.form, 'form');
    }
}

</script>